import React, { useState } from 'react';
import axios from 'axios';


export default ({
  ...props
}) => {
  
  const BASE_URL = 'https://d10d1s8yt56284.cloudfront.net/api/v1';
  
  const [isProductExist, setIsProductExist] = useState(null);
  const [value, setValue] = useState(null);

  const handleOnVerify = async () => {
    if (!value) return;
    try {
      const res = await axios.get(BASE_URL + '/serial-codes/' + value);
      if (res.status === 200) {
        setIsProductExist(true);
      } else {
        setIsProductExist(false);
      }
    } catch (e) {
      setIsProductExist(false);
    }    
  }

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>
        Product<br/>Verification
      </h1>
      <p style={styles.subtitle}>
        Please scratch and enter the unique<br/>product code located at the back of<br/>your product.
      </p>
      <div
        style={styles.form}
      >
        { isProductExist !== null &&
          <div 
            style={{ 
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <img src={isProductExist ? require('../assets/check.png'):  require('../assets/cross.png')} 
              style={{
                height: 100,
                width: 100
              }}
            />
            <h3
              style={{textAlign: 'center', color: isProductExist ? '#2EB396' : '#F22F3F' }}
            >
              {isProductExist ? `PRODUCT FOUND` : "THIS PRODUCT DOESN'T EXIST!" }
              <br />
              { !isProductExist && `BE CAREFUL OF COUNTERFEITING`}
              
            </h3>
            
          </div>
        }
        <input
          style={styles.input} 
          type="text"
          placeholder='Enter code here'
          onChange={(e) => setValue(e.target.value)}
          value={value}
        />
        <button
          style={styles.button}
          disabled={!value}
          onClick={handleOnVerify}
        >
          VERIFY
        </button>
      </div>
    </div>
  )
}

const styles = {
  container: {
    backgroundColor: '#A77570',
    border: '1px solid #A77570',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    borderBottomLeftRadius: '20px',
    borderBottomRightRadius: '20px',
    padding: '30px 30px 70px 30px',
    maxWidth: 400,
  },
  title: {
    color: 'white',
    textAlign: 'center',
  },
  subtitle: {
    textAlign: 'left',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  input: {
    border: 'none',
    borderRadius: 5,
    height: '40px',
    display: 'flex',
    padding: '0px 10px',
    fontSize: '18px',
    margin: '10px 0px',
  },
  button: {
    height: '40px',
    border: 'none',
    borderRadius: 5,
    color: 'white',
    fontSize: '18px',
    fontWeight: 'bold',
    backgroundColor: '#A8A8A8',
    cursor: 'pointer',
    width: '100%'
  }
}